import optionTypes from './optionTypes';

const ballotOptionTypeOrder = [
  optionTypes.winner.key,
  optionTypes.eventBoolean.key,
  optionTypes.eventCount.key,
  optionTypes.pass.key,
] as const;

export default ballotOptionTypeOrder;
